import React from "react"

function DsaCppCodeFile({ link, title }) {
  return (
    <div className="my-2 p-2">
      <h4>Code file</h4>
      <p className="text-muted">
        Please open this in your pc or with a compatible app in your mobile.
      </p>
      <a
        download
        href={link}
        target="_blank"
        rel="noreferrer"
        role="button"
        className="btn btn-sm btn-dark"
      >
        <em className="fas fa-external-link-alt mr-2"></em> C++ Implementation
        for {title}
      </a>
    </div>
  )
}

export default DsaCppCodeFile
